// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"247f7025","87":"afd762a1","215":"9d48fd90","256":"29f6210a","367":"7239e89d","422":"b07d2b26","474":"3b0272a9","543":"8efbcdd1","694":"a8de25c8","754":"3c271dcb"}[chunkId] + ".chunk.js";
};